import { useTranslation } from 'react-i18next';

import type { Option } from 'components/shared/ControlledFields/ControlledSelect';

/**
 * The childcare types, in the order of the school day for the three school-bound ones: before
 * school, midday, after school. Fixed on the backend as well — adding a value costs a release and a
 * data correction per tenant, so this list is not tenant-configurable.
 */
export const CHILDCARE_TYPES = [
  'DAY_CARE',
  'PRESCHOOL',
  'OUT_OF_SCHOOL_CARE',
  'BEFORE_SCHOOL_CARE',
  'MIDDAY_CARE',
  'AFTER_SCHOOL_CARE',
  'CHILDMINDER_CARE'
] as const;

export type ChildcareType = (typeof CHILDCARE_TYPES)[number];

export const useChildcareTypeOptions = (): Option[] => {
  'use memo';
  const { t } = useTranslation('common');

  return CHILDCARE_TYPES.map((type) => ({
    value: type,
    label: t(`costCenterDetail.childcareTypes.${type}`)
  }));
};
